export function validateRedirectUrl(url: string | null | undefined): string | null {
  if (!url) return null
  if (!url.startsWith('/')) return null
  if (url.startsWith('//')) return null
  return url
}
